import { render, staticRenderFns } from "./DataImplementation.vue?vue&type=template&id=f65cee3a&scoped=true&"
import script from "./DataImplementation.vue?vue&type=script&lang=js&"
export * from "./DataImplementation.vue?vue&type=script&lang=js&"
import style0 from "./DataImplementation.vue?vue&type=style&index=0&id=f65cee3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65cee3a",
  null
  
)

export default component.exports